<ng-container *ngIf="savedCart$ | async as cart">
  <div class="saved-cart-actions-container">
    <cx-export-order-entries></cx-export-order-entries>

    <div class="fake-col">
      <button #element class="btn btn-secondary" (click)="openDialog(cart, savedCartFormType.DELETE)">
        {{ 'savedCartDetails.deleteSavedCart' | cxTranslate }}
      </button>
    </div>

    <div class="fake-col">
      <button #element class="btn btn-primary" (click)="openDialog(cart, savedCartFormType.RESTORE)">
        {{ 'savedCartList.makeCartActive' | cxTranslate }}
      </button>
    </div>
  </div>
</ng-container>
